import { cn } from '@talentmesh/ui/lib/utils';
import React from 'react';

const BlueRibbonDialog = ({
    children,
    className,
    ...props
}: React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>) => {
    return (
        <div
            className={cn(
                'bg-primary text-primary-foreground w-max px-5 py-2.5 transition-colors duration-200',
                'rounded-tl-none rounded-tr-none rounded-br-md rounded-bl-md',
                className,
            )}
            {...props}
        >
            <span className="text-lg leading-tight font-medium">{children}</span>
        </div>
    );
};

export default BlueRibbonDialog;
